




















import { PropType } from 'vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { UseService } from '@/services/service';
import BulletinReactionService from '@/services/bulletin-reaction.service';
import { BulletinEntity } from '@/entities/bulletin.entity';
import BulletinReactionButtonAdd from '@/components/ViewComponent/Bulletin/Reaction/BulletinReactionButtonAdd.vue';
import BulletinReactionItem from '@/components/ViewComponent/Bulletin/Reaction/BulletinReactionItem.vue';

@Component<ReactionBulletin>({
  components: {
    BulletinReactionItem,
    BulletinReactionButtonAdd,
  },
})
export default class ReactionBulletin extends Vue {
  @Prop({ type: Object as PropType<BulletinEntity> })
  bulletin: BulletinEntity;

  @UseService(BulletinReactionService)
  service: BulletinReactionService;
}
